import { render, staticRenderFns } from "./stateItem.vue?vue&type=template&id=c0080124&scoped=true"
import script from "./stateItem.vue?vue&type=script&lang=js"
export * from "./stateItem.vue?vue&type=script&lang=js"
import style0 from "./stateItem.vue?vue&type=style&index=0&id=c0080124&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c0080124",
  null
  
)

export default component.exports